export const iconFontAwesomeDesignFillDrip = (
	<i className="fa-solid fa-fill-drip"></i>
);
